export const allMarginDatalist = [
  { value: "0", style: "m-0" },
  { value: "px", style: "m-px" },
  { value: "0.5", style: "m-0.5" },
  { value: "1", style: "m-1" },
  { value: "1.5", style: "m-1.5" },
  { value: "2", style: "m-2" },
  { value: "2.5", style: "m-2.5" },
  { value: "3", style: "m-3" },
  { value: "3.5", style: "m-3.5" },
  { value: "4", style: "m-4" },
  { value: "5", style: "m-5" },
  { value: "6", style: "m-6" },
  { value: "7", style: "m-7" },
  { value: "8", style: "m-8" },
  { value: "9", style: "m-9" },
  { value: "10", style: "m-10" },
  { value: "11", style: "m-11" },
  { value: "12", style: "m-12" },
  { value: "14", style: "m-14" },
  { value: "16", style: "m-16" },
  { value: "20", style: "m-20" },
];
export const topMarginDatalist = [
  { value: "0", style: "mt-0" },
  { value: "px", style: "mt-px" },
  { value: "0.5", style: "mt-0.5" },
  { value: "1", style: "mt-1" },
  { value: "1.5", style: "mt-1.5" },
  { value: "2", style: "mt-2" },
  { value: "2.5", style: "mt-2.5" },
  { value: "3", style: "mt-3" },
  { value: "3.5", style: "mt-3.5" },
  { value: "4", style: "mt-4" },
  { value: "5", style: "mt-5" },
  { value: "6", style: "mt-6" },
  { value: "7", style: "mt-7" },
  { value: "8", style: "mt-8" },
  { value: "9", style: "mt-9" },
  { value: "10", style: "mt-10" },
  { value: "11", style: "mt-11" },
  { value: "12", style: "mt-12" },
  { value: "14", style: "mt-14" },
  { value: "16", style: "mt-16" },
  { value: "20", style: "mt-20" },
];
export const bottomMarginDatalist = [
  { value: "0", style: "mb-0" },
  { value: "px", style: "mb-px" },
  { value: "0.5", style: "mb-0.5" },
  { value: "1", style: "mb-1" },
  { value: "1.5", style: "mb-1.5" },
  { value: "2", style: "mb-2" },
  { value: "2.5", style: "mb-2.5" },
  { value: "3", style: "mb-3" },
  { value: "3.5", style: "mb-3.5" },
  { value: "4", style: "mb-4" },
  { value: "5", style: "mb-5" },
  { value: "6", style: "mb-6" },
  { value: "7", style: "mb-7" },
  { value: "8", style: "mb-8" },
  { value: "9", style: "mb-9" },
  { value: "10", style: "mb-10" },
  { value: "11", style: "mb-11" },
  { value: "12", style: "mb-12" },
  { value: "14", style: "mb-14" },
  { value: "16", style: "mb-16" },
  { value: "20", style: "mb-20" },
];
export const leftMarginDatalist = [
  { value: "0", style: "ml-0" },
  { value: "px", style: "ml-px" },
  { value: "0.5", style: "ml-0.5" },
  { value: "1", style: "ml-1" },
  { value: "1.5", style: "ml-1.5" },
  { value: "2", style: "ml-2" },
  { value: "2.5", style: "ml-2.5" },
  { value: "3", style: "ml-3" },
  { value: "3.5", style: "ml-3.5" },
  { value: "4", style: "ml-4" },
  { value: "5", style: "ml-5" },
  { value: "6", style: "ml-6" },
  { value: "7", style: "ml-7" },
  { value: "8", style: "ml-8" },
  { value: "9", style: "ml-9" },
  { value: "10", style: "ml-10" },
  { value: "11", style: "ml-11" },
  { value: "12", style: "ml-12" },
  { value: "14", style: "ml-14" },
  { value: "16", style: "ml-16" },
  { value: "20", style: "ml-20" },
];
export const rightMarginDatalist = [
  { value: "0", style: "mr-0" },
  { value: "px", style: "mr-px" },
  { value: "0.5", style: "mr-0.5" },
  { value: "1", style: "mr-1" },
  { value: "1.5", style: "mr-1.5" },
  { value: "2", style: "mr-2" },
  { value: "2.5", style: "mr-2.5" },
  { value: "3", style: "mr-3" },
  { value: "3.5", style: "mr-3.5" },
  { value: "4", style: "mr-4" },
  { value: "5", style: "mr-5" },
  { value: "6", style: "mr-6" },
  { value: "7", style: "mr-7" },
  { value: "8", style: "mr-8" },
  { value: "9", style: "mr-9" },
  { value: "10", style: "mr-10" },
  { value: "11", style: "mr-11" },
  { value: "12", style: "mr-12" },
  { value: "14", style: "mr-14" },
  { value: "16", style: "mr-16" },
  { value: "20", style: "mr-20" },
];
